export default "__VITE_ASSET__V3F6LxCa__"